import AddIcon from "@mui/icons-material/AddRounded";
import { Button, Stack, Typography } from "@mui/material";
import BankDialogIcon from "@entrilia/shared/icons/BankDialogIcon";
import useBankAccountsContext from "./useBankAccountsContext";

interface Props {
  canEdit: boolean;
  onAddBankAccount: () => void;
}

const NoBankAccounts = ({ canEdit, onAddBankAccount }: Props) => {
  const { availableFundInvestorIds } = useBankAccountsContext();

  return (
    <Stack spacing={2} sx={{ width: "25rem", alignItems: "center" }}>
      <BankDialogIcon sx={{ width: 80, height: 80 }} />
      <Typography color="textSecondary">
        You do not have any bank accounts yet. These bank accounts will be used to receive distributions from your fund
        investments.
      </Typography>
      {canEdit && (
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onAddBankAccount}
          disabled={availableFundInvestorIds.length === 0}
        >
          Add Bank Account
        </Button>
      )}
    </Stack>
  );
};

export default NoBankAccounts;
